import React, { Component } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import {callPOST} from '../../../../Utils/ApiUtil';
import {fileNameShortenForDisplay,isSet,parameterizedURLAccessToken} from '../../../../Utils/CommonFunctions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  loader,
} from '../../../../store/actions/auth';
import {
  failMessage,
  succMessage
} from '../../../../store/actions/CommonActions';


class FileUpload extends Component {

  fileObj = [];
  fileArray = [];

    constructor(props) {
        super(props)
        this.state = {
            files: [],
            totalSize:0,
        }
        this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this)
        this.uploadFiles = this.uploadFiles.bind(this)
    }
    updateFilesSizes = ()=>{
      
    }

    uploadFileAPICall= (files)=>{
      let totalFileLength = this.props.item.files.length+files.length;
      if(totalFileLength>Number(this.props.item.max)){
        this.props.failMessage('You can upload a maximum of '+this.props.item.max+' files only');
        return false; 
      }  
      this.props.Loader(true);
      Object.entries(files).map(([key, fileItem]) => {
        const formData = new FormData();            
        formData.append("upload_file", fileItem);
        const APIURL = 'files/upload';
        callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
        .then(res => {  
          this.props.Loader(false);  
          if(res.status==200){                        
            const response = res.data;
            if(response.code===200){
                const responseData =  response.data;
                let filesArr = this.props.item.files;
                filesArr.push({
                  id:responseData,
                  value:responseData,
                  checked:null,
                  file:fileItem,
                  label:fileItem.name,
                  size:fileItem.size
                });
                this.props.onChangeInputAction(this.props.fieldObj,filesArr,'Files');
                this.updateFilesSizes();
              }else{
                this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
              }                                                
          }else{
              // this.props.Loader();
              this.props.failMessage('Something went wrong..');
          }
        })
        .catch(err => {
            console.log(err);
            this.props.Loader(false);
            // this.props.Loader();
            this.props.failMessage('Something went wrong');                    
        })
    })
  }
    uploadMultipleFiles(e) {
      let updateFiles = this.state.files;
      this.uploadFileAPICall(e.target.files);
      updateFiles.push(e.target.files)
      // console.log(e.target.files);
      this.setState({files:updateFiles});
      // console.log(this.state.files);
      this.updateFilesSizes();
    }

    uploadFiles(e) {
        e.preventDefault()
        // console.log(this.state.file);
    }
    onFileChange =()=>{
      if(this.props.item.modType==='LAYOUT'){
        return false;
      }
      // console.log(this.props);
      if(this.props.item.files.length>Number(this.props.item.max)){
        this.props.failMessage('Maximum '+this.props.item.max+' files allowed');
        return false;
      }  
      var inputField = this.refs.uploadMultipleFiles;
      console.log(inputField);
      inputField.click();
    }  
    changeHandlerFile =(event)=>{
    //  console.log(event.target.files[0]);
    }
    removeAddedFile = (Fileindex)=>{
      let updateFiles = this.props.item.files;
      updateFiles = updateFiles.filter((item,index)=>{
        if(index!== Fileindex){
          return item;
        }
      })
      // this.setState({files:updateFiles});
      this.props.onChangeInputAction(this.props.fieldObj,updateFiles,'Files');
      this.updateFilesSizes();
    }
  render() {
    const  {
      item,
      className,
      validationForms,
    } = this.props;

    
    
    const attr = formFieldsAttributes(
      {...item,className:className
    },validationForms);
    const filesLength = isSet(item.files,[]).length;
    // console.log(item.files);
    return (
      <FormBlocks {...this.props}  attr={attr}>
          <div className="border" style={{borderRadius:'0.25rem',padding:'5px',width:'100%'}}>
				<div className="position-relative">
                <input type="file" ref="uploadMultipleFiles" multiple={(item.max>1)?'multiple':''} style={{display:'none'}} onChange={this.uploadMultipleFiles}/>
                
					<div className="border-bottom card-title mb-2 cursor-pointer" onClick={this.onFileChange}>
          <div className="totalFileSize text-left">
              Maximum <b className="proximas">{this.props.item.max}&nbsp;</b>
               files allowed
          </div>
          <div className="text-right">  
              <i className="fas fa-upload secondary_color"></i> <small>Upload New</small>
            </div>
					</div>
				</div>
				
            {(filesLength>0)?
              <div className="row">
                <div className="col-12">
                  {
                    item.files.map((itemFile,index)=>{
                      const ext = itemFile.label.split('.').pop();
                      let fileIcon = 'fas fa-file';
                      let roundedClass = '';
                      if(ext==='pdf'){
                        fileIcon = 'fas fa-file-pdf';
                        roundedClass = 'bg-danger';
                      }else if(ext==='doc' || ext==='docx'){
                        fileIcon = 'far fa-file-word';
                        roundedClass = 'bg-info';
                      }else if(ext==='xls' || ext==='xlsx'){
                        fileIcon = 'far fa-file-excel';
                        roundedClass = ' bg-success';
                      }else if ((itemFile.label).match(/.(jpg|jpeg|png|gif)$/i)){
                        fileIcon = 'fas fa-upload';
                        roundedClass = ' bg-success';
                      }
                      const itemFileLabel = fileNameShortenForDisplay(itemFile.label);
                      return(
                        <div key={index}>
                        <div className="d-flex">
                          <div className="avatar avatar-sm">
                            <span className={"avatar-title rounded-circle border border-white "+roundedClass}><i className={fileIcon}></i></span>
                          </div>
                          <div className="flex-1 ml-3 pt-1">
                            <h6 className="fw-bold mb-1">{itemFileLabel}</h6>
                          </div>
                          <div className="float-right pt-1">
                            <small className="text-muted" onClick={this.callDownloadImgFile.bind(this,itemFile)}><i className="fas fa-download fa-lg cursor-pointer"></i></small>&nbsp;&nbsp;
                            <small className="text-muted" onClick={this.removeAddedFile.bind(this,index)}><i className="far fa-trash-alt fa-lg cursor-pointer"></i></small>
                          </div>
                        </div>
								      <div className="separator-dashed m-1"></div>
                      </div>
                      )
                    })
                  }
                </div>
              </div>
            :
            <div className="text-center">
				      <i className="fas fa-file-image fa-2x last_light_color"></i>
              <p className="last_light_color mb-0 text-small"> No Files added</p>
            </div>
            }
            </div>
       </FormBlocks>
    );
  }

  callDownloadImgFile = (itemFile) => {
    document.location.href = parameterizedURLAccessToken('files/download?fileId='+itemFile.id);
  }

}

FileUpload.defaultProps = {
  generator: false,
  className: "form-control"
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : (boll) => dispatch(loader(boll)),
    succMessage : (msg) => dispatch(succMessage(msg)),
    failMessage : (msg) => dispatch(failMessage(msg)),
  };
}
export default
  connect(
    null, 
    mapDispatchToProps
  )(withRouter(FileUpload));